<template>
    <main role="main">
        <article class="layout-contents-container">
            <settings-header :menu="'2'"></settings-header>
            <div class="layout-contents">
                <div class="tbl-header">
                    <div class="inner">
                        <h2 class="title">
                            {{$t('SETTING.CATEGORY.HEADER.TITLE')}}
                            <button type="button" class="buttons-icon tooltipstered" data-type="ghost" data-icon="info" data-size="s" data-trigger="tooltip-right"
                                    v-bind:title="$t('SETTING.CATEGORY.HEADER.TOOLTIP')">
                            </button>
                        </h2>
                        <p class="desc">{{originCategoryList.length}} {{$t('SETTING.CATEGORY.HEADER.DESC')}}</p>
                    </div>
                </div>

                <div class="tbl-contents-container">
                    <fieldset class="tbl-filters">
                        <legend>table filters</legend>

                        <div class="search-bar">
                            <input type="search" class="selected"
                                   v-bind:placeholder="$t('COMMON.SEARCH.ENTER_SEARCH_TEXT')"
                                   :disabled="isDisabled()"
                                   v-model="searchTxt">
                            <i class="icon"></i>

                            <button v-show="searchTxt !== ''" type="button" class="buttons-icon" data-type="ghost" data-size="s" data-icon="clear" v-on:click="searchTxt = ''">Reset</button>
                        </div>

                    </fieldset>

                    <table class="tbl-default v-top" v-bind:data-edit-mode="(isEdit != null && isEdit > -1) ? true : null">
                        <colgroup>
                            <col style="width: 294px;">
                            <col>
                        </colgroup>
                        <thead>
                        <tr>
                            <th scope="col">

                                <button type="button" class="buttons-tbl-header"  v-on:click="setSortColumn()"
                                        v-bind:data-type="sortOrder === 'asc' ? 'sort-asce' : sortOrder === 'desc' ? 'sort-desc' : 'sort'">{{$t('SETTING.CATEGORY.TABLE.CATEGORY_NAME')}}</button>
                            </th>
                            <th scope="col">
                                {{$t('SETTING.CATEGORY.TABLE.LINKED_RULE')}}
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(category, index) in categoryList" :key="index">
                            <!--Category name-->
                            <th scope="row" class="category-label">
                                <span class="ellipsis">
                                {{category.ctgLabel}}
                                </span>

                                <div v-if="getMenuAuth == constants.AUTH_TYPE.EDIT" class="actions">
                                    <button type="button" class="buttons-icon" data-type="ghost" data-size="s" data-icon="edit"
                                            :disabled="isDisabled()"
                                            v-if="category.dflYn === 'N'"
                                            @click="isEdit = index">{{$t('COMMON.BUTTON.CAMEL.EDIT')}}</button>
                                    <button type="button" class="buttons-icon" data-type="ghost" data-size="s" data-icon="delete" data-trigger="delete"
                                            :disabled="isDisabled()"
                                            v-if="(category.ruleInfo == null || category.ruleInfo.length === 0 ) && category.dflYn === 'N'"
                                            @click="deleteCategory(category)">{{$t('COMMON.BUTTON.CAMEL.DELETE')}}</button>
                                </div>

                                <!-- 수정 레이어 -->
                                <fieldset class="edit-layer" v-if="isEdit === index">
                                    <legend>{{$t('SETTING.CATEGORY.CHANGE_LEVEL')}}</legend>

                                    <input type="text"
                                           v-model="category.ctgLabel"
                                           :data-invalid="invalidCategoryLabel"
                                    >
                                    <div class="invalid-icon" v-if="invalidCategoryLabel">
                                        <p class="invalid-message">{{invalidCategoryLabelMsg}}</p>
                                    </div>

                                    <div class="actions">
                                        <button type="button" class="buttons-icon" data-type="ghost" data-size="s" data-icon="confirm" @click="saveCategory(category)">{{$t('COMMON.BUTTON.CAMEL.OK')}}</button>
                                        <button type="button" class="buttons-icon" data-type="ghost" data-size="s" data-icon="cancel" @click="cancelEdit()">{{$t('COMMON.BUTTON.CAMEL.CANCEL')}}</button>
                                    </div>
                                </fieldset>
                            </th>

                            <!--Rule Section-->
                            <td v-if="category.ruleInfo!= null && category.ruleInfo.length >0">
                                <ul class="list-rules">
                                    <li v-for="(rule, idx) of category.ruleInfo" :key="idx">
                                        <router-link :to="'/policy/detail?rvsn='+rule.plcyRvsnId">{{rule.userDefiYn == constants.PARAM.SELECT.N ? rule[$i18n.locale+'RuleTitle'] : rule.titl}}</router-link>
                                    </li>
                                </ul>
                            </td>
                            <td v-else>
                                {{$t('SETTING.CATEGORY.MESSAGE.NO_LINKED_RULE')}}
                            </td>

                        </tr>
                        <tr v-if="!pending && categoryList.length == 0">
                            <td colspan="2">
                                <div class="tbl-collapse" data-linkable-row>
                                    <div class="tbody">
                                        <div class="row none with-button">
                                            <div class="cells">
                                                <div class="cell">
                                                    {{$t('COMMON.NO_DATA')}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>

                    <div v-if="getMenuAuth == constants.AUTH_TYPE.EDIT" class="tbl-actions">
                        <button type="button" class="buttons" data-type="line" data-size="s" data-icon="add"
                                :disabled="categoryList.length > 49 || isEdit > -1"
                                @click="addCategory()">
                            {{$t('SETTING.CATEGORY.BUTTON.ADD_CATEGORY')}}
                        </button>
                    </div>

                </div>
            </div>

        </article>
        <div-loading v-if="pending" :full="true"></div-loading>
        <confirm-popup ref="confirmPopup"></confirm-popup>
    </main>

</template>



<script>

    import settingsHeader from './settingsHeader.vue';
    import ConfirmPopup from "../common/confirmPopup";
    import {mapGetters} from "vuex";

    export default {
        name: 'settings-category',
        components: {
            ConfirmPopup,
            settingsHeader
        },
        data: function () {
            return {
                categoryList: [] // Category List
                , originCategoryList: []
                , invalidCategoryLabel: false
                , invalidCategoryLabelMsg: ''
                , isEdit: null
                , pending: false
                , searchTxt: ''
                ,
                sortColumn: '',                                // Sort column
                sortOrder: '',                                 // Sort order
            }
        },
        created: function () {
            this.selectCategoryList();
        },
        computed: {
            ...mapGetters({
                curCmpnId: 'user/curCmpnId'
            }),
            getMenuAuth: function(){
                //메뉴 별 권한
                let auth = _.find(this.$store.state.GOV_MENU_AUTH, {menuId: this.constants.MENU.SETTINGS})
                return auth ? auth.authTypeCd : this.constants.AUTH_TYPE.NONE
            }
        },
        watch: {
            curCmpnId: function () {
                this.selectCategoryList();
            },
            searchTxt: function () {
                let self = this
                this.categoryList = _.filter(this.originCategoryList, function (o) {
                    return o.ctgLabel.toLowerCase().includes(self.searchTxt.toLowerCase());
                });
            }
        },
        methods: {

            initView(){
                let target = $('[data-trigger="tooltip-right"]');
                target.tooltipster({
                    delay: 300,
                    // trigger: 'click',
                    animation: 'fade',
                    updateAnimation: 'fade',
                    position: 'right',
                    arrow: true,
                    contentAsHTML: true,
                    interactive: true
                });
            },

            isDisabled: function () {
                return this.isEdit > -1;
            },
            // 카테고리 추가 폼 만들기
            addCategory: function () {
                this.categoryList.push({
                    cmpnId: this.curCmpnId,
                    ctgLabel: ""
                });
                this.isEdit = this.categoryList.length - 1;
            },
            // 등록 / 수정 취소
            cancelEdit: function () {
                this.isEdit = -1;
                this.invalidCategoryLabel = false;
                this.categoryList = _.cloneDeep(this.originCategoryList);
            },
            selectCategoryList: function () {
                var url = `/api/governance/category/list`;
                var header = {
                    'cmpnId': this.curCmpnId
                };

                this.pending = true;
                this.http.post(url, JSON.stringify(header))
                    .then(result => {
                        this.pending = false;

                        let list = result.data.result;
                        this.isEdit = -1;

                        this.categoryList = [];

                        // category id 를 기준으로 groupby
                        this.categoryList = _.chain(list)
                            .groupBy("ctgId")
                            .map((value, key) => ({ ctgId: key }))
                            .value();

                        for(let i =0; i<this.categoryList.length;i++){
                            this.categoryList[i] = _.find( list, { "ctgId" : this.categoryList[i].ctgId});
                            let data =_.reject(_.filter(list, {"ctgId" : this.categoryList[i].ctgId}), { ruleRvsnId : null });
                            this.categoryList[i].ruleInfo = data.length > 0 ? data : null;
                        }

                        this.originCategoryList = _.cloneDeep(this.categoryList);

                        this.$nextTick(function () {
                            this.initView();
                        })
                    });
                //*/
            },

            // 카테고리 레이블 유효성 검사
            isInvalidCategoryLabel: function (category) {

                const inValidWhiteSpace = /\s/;
                if (!category.ctgLabel || category.ctgLabel.length == 0 || inValidWhiteSpace.test(category.ctgLabel)) {
                    this.invalidCategoryLabel = true;
                    this.invalidCategoryLabelMsg = this.$t('SETTING.WHITELIST.ERROR.NAME_NONE');
                } else if (category.ctgLabel.length > 20) {
                    this.invalidCategoryLabel = true;
                    this.invalidCategoryLabelMsg = this.$t('SETTING.WHITELIST.ERROR.MAX', {'cnt': 20});
                } else {
                    this.invalidCategoryLabel = false;
                }
                return this.invalidCategoryLabel;
            },

            // 카테고리 수정 확인 버튼
            saveCategory: function (category) {

                // 유효성 검사
                if (this.isInvalidCategoryLabel(category)) return;

                if (category.ctgId) {
                    this.updateCategory(category);
                } else {
                    this.insertCategory(category);
                }
            },

            // 카테고리 등록
            insertCategory: function (category) {
                var url = `/api/governance/category`;

                // TODO :: JSON.stringify() 하니까 Content type 'application/x-www-form-urlencoded;charset=UTF-8' not supported 나옴
                this.http.put(url, category)
                    .then(result => {
                        if (result.data.status == 'ok') {
                            this.selectCategoryList();
                            this.invalidCategoryLabel = false;
                        } else {
                            this.invalidCategoryLabelMsg = this.$t('SETTING.CATEGORY.ERROR.DUPLICATE_NAME');
                            this.invalidCategoryLabel = true;
                        }
                    });
            },

            // 카테고리 수정
            updateCategory: function (category) {
                let data = {
                    siteCd : category.siteCd,
                    cmpnId : category.cmpnId,
                    ctgId : category.ctgId,
                    ctgLabel : category.ctgLabel
                };

                let url = `/api/governance/category/update`;

                this.http.post(url, JSON.stringify(data))
                    .then(response => {
                        if (response.data.status == 'ok') {
                            this.selectCategoryList();
                            this.invalidCategoryLabel = false;
                        } else {
                            this.invalidCategoryLabelMsg = this.$t('SETTING.CATEGORY.ERROR.DUPLICATE_NAME');
                            this.invalidCategoryLabel = true;
                        }
                    });
            },

            // 카테고리 삭제
            deleteCategory: function (category) {
                let self = this;
                this.$refs.confirmPopup.open(self.$t("SETTING.CATEGORY.POPUP.TITLE.DELETE"), self.$t("SETTING.CATEGORY.POPUP.DESC.DELETE"), function (result) {
                    if (result) {
                        let url = `/api/governance/category/delete`;

                        this.http.post(url, JSON.stringify(category))
                            .then(response => {
                                if (response.data.status == 'ok') {
                                    self.selectCategoryList();
                                    self.invalidCategoryLabel = false;
                                } else {
                                    self.invalidCategoryLabel = true;
                                }
                            });
                    }
                })

            },

            // 카테고리 검색
            searchCategory: function (text) {
                this.categoryList = _.filter(this.originCategoryList, function (o) {
                    return o.ctgLabel.toLowerCase().includes(text.toLowerCase());
                });
            },
            setSortColumn(){
                if(this.sortOrder === ''){
                    this.sortOrder = 'asc'
                } else if (this.sortOrder === 'asc') {
                    this.sortOrder = 'desc'
                } else if (this.sortOrder === 'desc') {
                    this.sortColumn = ''
                    this.sortOrder = ''
                }
                this.categoryList = _.orderBy(this.categoryList, [ctg => ctg.ctgLabel.toLowerCase()] ,[ this.sortOrder]);
            },
            goPolicy(rvsnId) {
                const url = "/policy/detail";
                this.$router.push({path: url, query: {rvsn: rvsnId}});
            },
        }
    }

</script>




// WEBPACK FOOTER //
// src/components/settings/settingsCategory.vue